import React from 'react';
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Sidebar } from './Sidebar';
import { BottomNav } from './BottomNav';
import { NotificationBell } from '@/components/NotificationBell';
import { WhatsNewModal } from '@/components/WhatsNewModal';
import { PwaInstallBanner } from '@/components/PwaInstallBanner';

// Pages reached from the bottom bar or the menu; every other page gets a back arrow.
const TOP_LEVEL = ['/dashboard', '/leagues', '/matches', '/profile', '/facilities', '/search', '/announcements', '/referees', '/admin'];
const isTopLevel = (path) => TOP_LEVEL.includes(path) || /^\/facilities\/[^/]+\/dashboard$/.test(path);

const MobileHeader = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  // React Router counts its own history entries: idx 0 = the app was opened on this page.
  const goBack = () => (window.history.state?.idx > 0 ? navigate(-1) : navigate('/dashboard'));
  return (
  <header
    className="safe-mobile-header md:hidden sticky top-0 z-40 border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60"
    data-testid="mobile-header"
  >
    <div className="flex items-center justify-between h-14 px-3">
      <div className="flex items-center gap-1">
      {!isTopLevel(pathname) && (
        <button
          type="button"
          onClick={goBack}
          aria-label="Indietro"
          data-testid="header-back"
          className="-ml-1.5 flex h-10 w-10 items-center justify-center rounded-full hover:bg-muted active:bg-muted"
        >
          <ArrowLeft className="h-5 w-5" />
        </button>
      )}
      <Link to="/dashboard" className="flex items-center gap-2">
        <img src="/logo.png" alt="LeagueHub" className="h-7 w-auto" />
        <span className="text-base font-bold tracking-tight">
          League<span className="text-primary">Hub</span>
        </span>
      </Link>
      </div>
      <NotificationBell />
    </div>
  </header>
  );
};

export const Layout = () => {
  const location = useLocation();
  return (
    <div className="safe-app-shell flex bg-background">
      {/* Desktop Sidebar */}
      <Sidebar />

      {/* Main Content */}
      <main className="safe-app-main flex-1 min-w-0">
        <MobileHeader />
        <div className="max-w-7xl mx-auto w-full min-w-0">
          {location.pathname === "/dashboard" && <PwaInstallBanner />}
          <Outlet />
        </div>
      </main>

      {/* Mobile Bottom Navigation */}
      <BottomNav />

      {/* What's new modal */}
      <WhatsNewModal />
    </div>
  );
};

export default Layout;
